import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BsPersonCircle } from "react-icons/bs";
import { auth, db, listenAuthState } from "../firebase"; // Firebase initialization file
import { getDoc, doc } from "firebase/firestore";
import pic from '../assets/download.png';

const UserProfile = () => {
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const unsubscribe = listenAuthState(async (currentUser) => {
      if (currentUser) {
        setIsSignedIn(true);
        setUser(currentUser); // Set the user object directly (currentUser is available)

        const userDoc = await getDoc(doc(db, "users", currentUser.uid));
        if (userDoc.exists()) {
          setRole(userDoc.data().role); // Set the role from Firestore
        } else {
          console.log("No user data found in Firestore");
        }
      } else {
        setIsSignedIn(false);
        setUser(null);
        setRole(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await auth.signOut();
    setIsSignedIn(false);
    setUser(null);
    setRole(null);
  };

  return (
    <div className="flex items-center justify-center">
      
      {isSignedIn && user ? (
        <div className="relative group">
          <img
            src={user.photoURL || pic} // Use the photoURL for the avatar, or a placeholder
            alt="Profile"
            className="w-14 h-14 rounded-full cursor-pointer border-2 border-gray-300"
          />
          <div className="absolute top-16 left-0 bg-white border border-gray-200 shadow-lg rounded-md p-4 opacity-0 group-hover:opacity-100 transition-opacity">
            {/* Check if the user is a tourist or partner */}
            {role === "tourist" ? (
              <Link to="/tourist-profile" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 rounded-md">
                عرض ملف السياحي
              </Link>
            ) : role === "partner" ? (
              <Link to="/partner-profile" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 rounded-md">
                عرض ملف الشريك
              </Link>
            ) : null}
            <button
              className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 rounded-md mt-2"
              onClick={handleSignOut}
            >
              تسجيل الخروج
            </button>
          </div>
        </div>
      ) : (
        <Link to="/LoginSignUpPage" className="m-2 mr-4 hover:text-white">
          <BsPersonCircle className="text-4xl text-gray-600 hover:text-green-500 transition duration-300" />
        </Link>
      )}
    </div>
  );
};

export default UserProfile;
